import { Component, inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { DarkModeService } from "../../services/dark-mode.service";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  loading: boolean = false;

  form: FormGroup;
  hide = true;

  private fb: FormBuilder = inject(FormBuilder)
  private authService: AuthService = inject(AuthService)
  private notificationService: NotificationService = inject(NotificationService);
  private router: Router = inject(Router);
  private location: Location = inject(Location)
  private readonly darkModeService: DarkModeService = inject(DarkModeService);

  // Dark Mode State
  public activeLightMode: 'light' | 'night' = 'light';
  public isLightMode: boolean = true;

  ngOnInit() {
    this.form = this.fb.group({
      email: [null, Validators.required],
    });

    // Initialize dark mode state
    this.activeLightMode = this.darkModeService.isDarkMode ? 'night' : 'light';
    this.isLightMode = this.activeLightMode === 'light';
  }

  submitForm(value) {
    if (value.email) {
      this.authService.forgotPassword(value).then(
        async () => {
          await this.router.navigate(['', 'check-your-email']);
        }
      )
    } else {
      this.notificationService.errorMessage("Please enter a your email address");
    }
  }

  goBack() {
    this.location.back();
  }

  /**
   * Toggles between light and dark theme
   */
  public toggleTheme(): void {
    this.activeLightMode = this.isLightMode ? 'light' : 'night';
    this.darkModeService.toggleDarkMode();
  }
}
